import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const availableStatus: string[] = ['Pending', 'Acknowledged', 'Validated', 'Rejected', 'Expired'];

interface StatusFilterProps {
  value?: string;
  onSelect: (value?: string) => void;
}

export const StatusFilter: FC<StatusFilterProps> = ({ value, onSelect }) => {
  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover>
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        data-e2e="status-filter"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
      >
        <i className="icon">workspaces</i>
        <span className="d-none d-lg-inline">
          <FormattedMessage id={`priceImprovementBlotter.filter.status.${value || 'allStatus'}` as IntlKey} />
        </span>
      </DropdownToggle>
      <DropdownMenu role="listbox">
        <SpDropdownItem active={value === ''} onClick={() => onSelect('')}>
          <FormattedMessage id="priceImprovementBlotter.filter.status.allStatus" />
        </SpDropdownItem>
        {availableStatus.map(status => (
          <SpDropdownItem active={status === value} key={status} onClick={() => onSelect(status)}>
            <FormattedMessage
              id={`priceImprovementBlotter.filter.status.${status}` as IntlKey}
              defaultMessage={status}
            />
          </SpDropdownItem>
        ))}
      </DropdownMenu>
    </DropdownWrapper>
  );
};
